module.exports = __webpack_public_path__ + "img/device-3.18b31f74.png";